/** localStorage key prefix (suffixed with the user id) for the cached tab bar layout. */
export const NAV_LAYOUT_CACHE_KEY = "nav_layout_v1_";
